export default function Privacy() {
  return (
    <div className="max-w-3xl mx-auto px-5 sm:px-8 py-14 text-[#1A1A1A] leading-relaxed">
      <div className="text-xs uppercase tracking-[0.2em] text-[#C05A3D] font-semibold">Privacy</div>
      <h1 className="font-display text-4xl text-[#1E3A2F] mt-1">Privacy Policy</h1>
      <p className="text-sm text-[#5C5C5C] mt-2">Last updated: {new Date().toLocaleDateString()}</p>

      <div className="space-y-5 mt-8">
        <p>African Bridge Media respects your privacy. This policy explains what we collect and how we use it.</p>
        <h2 className="font-display text-2xl text-[#1E3A2F]">Information we collect</h2>
        <p>Account details (name, email, password hash), listings and events you post, images you upload, and basic usage information such as page views and reports you submit.</p>
        <h2 className="font-display text-2xl text-[#1E3A2F]">How we use it</h2>
        <p>We use your information to run your account, display your listings and events to the community, and to keep the platform safe. We do not sell personal information.</p>
        <h2 className="font-display text-2xl text-[#1E3A2F]">Content you post</h2>
        <p>Listings, events and images you post are public. Do not share sensitive personal information in public content.</p>
        <h2 className="font-display text-2xl text-[#1E3A2F]">Reports and moderation</h2>
        <p>Reports may be reviewed by our team. Content that violates our Terms may be removed.</p>
        <h2 className="font-display text-2xl text-[#1E3A2F]">Contact</h2>
        <p>Questions about privacy? Email hello@africanbridgemedia.com.</p>
      </div>
    </div>
  );
}
